<template>
  <div class="home">
    <innerHeader v-if="!isMobile"></innerHeader>
    <AppHeader v-if="isMobile" />
    <ResponsiveContainer>
      <div class="main">
        <!--cloumnId控制contentList  Tab的active -->
        <contentList
          @tabChagnge="tabChagnge"
          :tabList="tabList"
          :leftTab="6"
          v-if="!isMobile"
          class="bg"
        >
          <div slot="main_content">
            <div class="content_top">
              <div class="article_con"><register /></div>
            </div>
            <!-- <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="this.formData.dialogImageUrl" alt="" />
            </el-dialog> -->
          </div>
        </contentList>
        <AppcontentList
          @tabChagnge="tabChagnge"
          :tabList="tabList"
          :leftTab="5"
          v-if="isMobile"
          class="appbg"
          :ys="{ width: '100% ' }"
        >
          <div slot="main_content">
            <div class="app_content_top">
              <div class="article_con">
                <appRegister></appRegister>
              </div>
            </div></div
        ></AppcontentList>
        <!-- <paginations
          :current-page.sync="page.current"
          @current-change="currentChange"
          :page-size="page.size"
          :total="page.total"
        ></paginations> -->
      </div>
    </ResponsiveContainer>
    <Footer v-if="!isMobile" />
    <innerAppFooter v-else />
  </div>
</template>

<script>
import register from './component/register';
import appRegister from './component/appRegister';
import innerHeader from '@/components/innerHeader.vue';
import AppHeader from '@/components/AppHeader';
import Footer from '@/components/Footer.vue';
import innerAppFooter from '@/components/innerAppFooter';
import ResponsiveContainer from '@/components/ResponsiveContainer';
import contentList from '@/components/contentList';
import AppcontentList from '@/components/AppcontentList';
import paginations from '@/components/Pagination.vue';
import responsiveMixin from '@/mixins/responsiveMixin';
import { mediaTab } from '@/const';
export default {
  name: 'Memento',
  mixins: [responsiveMixin],
  components: {
    innerHeader,
    AppHeader,
    innerAppFooter,
    Footer,
    ResponsiveContainer,
    contentList,
    AppcontentList,
    paginations,
    register,
    appRegister,
  },
  data() {
    return {
      currentIndex: 0,
      tabList: mediaTab,
      cloumnId: null, //栏目id

      id: '',
    };
  },
  mounted() {},
  methods: {
    tabChagnge(column, cloumnId) {
      this.cloumnId = cloumnId;
      this.$router.push({ path: column.path });
      // this.getList();
    },
    currentChange(e) {
      this.current = e;
      // this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.main {
  .content_top {
    .article_con {
      width: 100%;
      box-sizing: border-box;
      overflow: hidden;
    }
  }
  .app_content_con {
    background: #fff;
  }
  .app_content_top {
    background: #fff;
    margin: 2rem 0 0;
    .article_con {
      background: #fff;
      width: 100%;
      box-sizing: border-box;
    }
  }
}

.appbg {
  width: 100%;
  background: url('../../assets/img/appImg/presi_bg.png') no-repeat left
    bottom/100% auto;
}
.bg {
  width: 100%;
  // background: url('../../assets/img/homeimgs/article_bg.png') no-repeat left
  //   bottom/100% auto;
  background: url('../../assets/img/homeimgs/article_bg.png') fixed;
}
</style>
